import { gql } from "@apollo/client";

export const PRIVACY_POLICY_QUERY = gql`
  query PrivacyPolicies {
    privacyPolicy {
      content
    }
  }
`
